import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { UtcToLocalDateTimePipe } from '@cms/shared-library';
import { TranslateService } from '@ngx-translate/core';
import { ClassNotification } from 'src/app/models/class-notification.model';
import { NotificationSearchForm } from 'src/app/models/notification-search.model'; 
import { NotificationService } from 'src/app/services/notification/notification.service';
import { NotificationHtmlSanitizerService } from 'src/app/services/sanitization/notification-html-sanitizer.service';

@Component({
    selector: 'app-notifications-list',
    templateUrl: './notifications-list.component.html',
    styleUrls: ['./notifications-list.component.scss'],
    providers: [{ provide: UtcToLocalDateTimePipe, useClass: UtcToLocalDateTimePipe }],
    standalone: false
})
export class NotificationsListComponent implements OnInit {
  @Input() public courseId: string
  selectedNotification: ClassNotification;
  notificationGroups: NotificationGrouping[] = []
  currentLang
  notifications: ClassNotification[] = []
  totalNotifications: number = 0
  unReadCount: number
  @Output() updatedUnreadCount = new EventEmitter<number>();

  notificationSearchForm = new NotificationSearchForm()

  constructor(public datePipe: DatePipe,
    public translateService: TranslateService,
    public utcDatePipe: UtcToLocalDateTimePipe, 
    public notificationHtmlSanitizer: NotificationHtmlSanitizerService,
    @Inject(LOCALE_ID) public locale: string,
    @Inject('NotificationService') public notificationService: NotificationService) {
    this.currentLang = translateService.currentLang
    this.datePipe = new DatePipe(this.currentLang == 'en' ? 'en-CA' : 'fr-CA')
    translateService.onLangChange.subscribe(lang => {
      this.currentLang = lang.lang;
    });

  }

  trustHtml(content: string | null | undefined): SafeHtml {
    return this.notificationHtmlSanitizer.sanitize(content, { preserveStyles: false });
  }

  ngOnInit(): void {
    this.notificationService.GetNotifications(this.courseId).subscribe(data => {
      this.displayNotifications(data);
    })
  }

  private displayNotifications(data: ClassNotification[]) {
    this.notifications = data;
    if (data.length > this.totalNotifications) this.totalNotifications = data.length;
    this.calculateUnreadCount();
    let days: any[] = this.notifications.map(x => this.datePipe.transform(this.utcDatePipe.transform(x.CreatedDate), 'yyyy-MM-dd')).filter((value, index, self) => self.indexOf(value) === index);
    days.forEach(y => {
      let matchingNotifications = this.notifications.filter(x => this.datePipe.transform(this.utcDatePipe.transform(x.CreatedDate), 'yyyy-MM-dd') == y);
      let ng = new NotificationGrouping(matchingNotifications[0].CreatedDate!, matchingNotifications);
      this.notificationGroups.push(ng);
    });

    this.sortNotifications();
  }

  selectNotification(notification: ClassNotification) {
    this.selectedNotification = notification
    if (notification.IsRead == null || !notification.IsRead) {
      this.selectedNotification.IsRead = true;
      this.notificationService.MarkNotificationAsReadOrDelete(notification.NotificationId).subscribe(data => {
        if (data) {
          this.calculateUnreadCount()
        }
      })

    }
  }

  getDate(date, format) {
    return this.datePipe.transform(date, format)
  }

  calculateUnreadCount() {
    this.notificationService.GetNotifications(this.courseId).subscribe(data => {
      this.notifications = data
      this.unReadCount = this.notifications.filter(notification => notification.IsRead == null || notification.IsRead == false).length
      this.updatedUnreadCount.emit(this.unReadCount)
    })

  }

  sortNotifications() {
    const sortDirection = (this.notificationSearchForm.sortingOption === 'Newest to oldest') ? 1 : -1;

    this.notificationGroups.sort((a, b) => {
      const aDate = new Date(a?.CreatedDate);
      const bDate = new Date(b?.CreatedDate);

      return sortDirection * (bDate.getTime() - aDate.getTime());
    });
  }

  handleNotificationSearchCriteriaChanged(notificationSearchForm: NotificationSearchForm) {
    notificationSearchForm.courseId = this.courseId;
    this.notificationGroups = [];
    this.notificationSearchForm = notificationSearchForm;
    this.notificationService.SearchNotifications(notificationSearchForm).subscribe((notifications: ClassNotification[]) => {
      this.displayNotifications(notifications);
    });
  }

}

export class NotificationGrouping {
  CreatedDate: Date
  Notifications: ClassNotification[]

  constructor(createdDate: Date, notifications: ClassNotification[]) {
    this.CreatedDate = createdDate
    this.Notifications = notifications
  }
}


